import verConfig from "./verConfig";

const formatMoney = (num, showUnit = true, unit = verConfig.moneyType) => {
  if (verConfig.homeProfitFormat) {
    num = moneyFormat(parseInt(num));
  }
  if (verConfig.moneyFormatWithBrazil) {
    num = formatWithBrazil(num);
  }
  if (!showUnit) {
    if(unit == 'đồng'){
      return modifyNumber(num)
    }
    return num
  }
  const type = unit;
  if (type == "₫") {
    return `${num}${type}`;
  } else if (type == "USDT") {
    return `${type} ${num} `;
  }else if(type == "đồng"){
    return `${modifyNumber(num)} ${type}`;
  }
  return `${type}${num}`;
}

const moneyFormat = (money) => {
  if (isNaN(Number(money))) return 0;
  const parts = money.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

const formatWithBrazil = (money) => {
  if (isNaN(Number(money))) return 0;
  money = money.toString();
  const int = money.split(".")[0];
  const decimal = money.split(".")[1] || "00";
  return `${moneyFormat(int)}.${decimal}`
}


const modifyNumber = (number)=> {
  let cleanedString=''
  if(number){
    cleanedString = number.replace(/\./g, '').replace(',', '.');
  }
  const parsedNumber = parseFloat(cleanedString);
  const roundedNumber = Math.round(parsedNumber * 100) / 100;

  if (roundedNumber === Math.floor(roundedNumber)) {
    // console.log(Math.floor(roundedNumber).toString());
    const formattedNumber = roundedNumber.toLocaleString().replace(/,/g, '.');
    return formattedNumber;
  } else {
    return number;
  }
}
export default formatMoney
